/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiMultipleResult,
    ApiResult,
    OfferDto,
    OfferRedemptionDto,
    OfferRequest,
} from "../models/index";
import {
    ApiMultipleResultFromJSON,
    ApiMultipleResultToJSON,
    ApiResultFromJSON,
    ApiResultToJSON,
    OfferDtoFromJSON,
    OfferDtoToJSON,
    OfferRedemptionDtoFromJSON,
    OfferRedemptionDtoToJSON,
    OfferRequestFromJSON,
    OfferRequestToJSON,
} from "../models/index";

export interface CreateOfferRequest {
    body?: OfferRequest;
}

export interface DeleteOfferRequest {
    offerId: number;
}

export interface GenerateOfferCodesRequest {
    offerId: number;
    count?: number;
    expiresAt?: Date;
}

export interface OfferRedemptionsRequest {
    offerId: number;
}

export interface RevokeOfferRedemptionRequest {
    offerId: number;
    userAccountId: number;
}

export interface RevokeOfferRedemptionsRequest {
    offerId: number;
}

export interface SetOfferDeviceGroupsRequest {
    offerId: number;
    deviceGroupTags?: Array<string>;
}

export interface UpdateOfferRequest {
    offerId: number;
    body?: OfferRequest;
}

/**
 *
 */
export class OfferHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Create a discount Offer for an organisation. New offers have no device groups: link groups via SetOfferDeviceGroups for the offer to apply to charge sessions.
     */
    async createOfferRaw(
        requestParameters: CreateOfferRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/offers/create`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: OfferRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Create a discount Offer for an organisation. New offers have no device groups: link groups via SetOfferDeviceGroups for the offer to apply to charge sessions.
     */
    async createOffer(
        requestParameters: CreateOfferRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.createOfferRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Delete an Offer with no redemptions (its codes are deleted too). An Offer with redemptions cannot be deleted: it is archived and its unredeemed codes invalidated instead. Existing redemptions keep their discount until they are revoked.
     */
    async deleteOfferRaw(
        requestParameters: DeleteOfferRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["offerId"] == null) {
            throw new runtime.RequiredError(
                "offerId",
                'Required parameter "offerId" was null or undefined when calling deleteOffer().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/offers/{offerId}`.replace(
                    `{${"offerId"}}`,
                    encodeURIComponent(String(requestParameters["offerId"])),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Delete an Offer with no redemptions (its codes are deleted too). An Offer with redemptions cannot be deleted: it is archived and its unredeemed codes invalidated instead. Existing redemptions keep their discount until they are revoked.
     */
    async deleteOffer(
        requestParameters: DeleteOfferRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deleteOfferRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Generate a batch of single-use redemption codes for an Offer. Codes are redeemed by EndUsers via the app\'s \'enter code\' flow.
     */
    async generateOfferCodesRaw(
        requestParameters: GenerateOfferCodesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiMultipleResult>> {
        if (requestParameters["offerId"] == null) {
            throw new runtime.RequiredError(
                "offerId",
                'Required parameter "offerId" was null or undefined when calling generateOfferCodes().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["count"] != null) {
            queryParameters["count"] = requestParameters["count"];
        }

        if (requestParameters["expiresAt"] != null) {
            queryParameters["expiresAt"] = (
                requestParameters["expiresAt"] as any
            ).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/offers/{offerId}/codes`.replace(
                    `{${"offerId"}}`,
                    encodeURIComponent(String(requestParameters["offerId"])),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiMultipleResultFromJSON(jsonValue),
        );
    }

    /**
     * Generate a batch of single-use redemption codes for an Offer. Codes are redeemed by EndUsers via the app\'s \'enter code\' flow.
     */
    async generateOfferCodes(
        requestParameters: GenerateOfferCodesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiMultipleResult> {
        const response = await this.generateOfferCodesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * List an Offer\'s redemptions. The redeeming user is included only for JC staff with system_user_account_manage permission
     */
    async offerRedemptionsRaw(
        requestParameters: OfferRedemptionsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<OfferRedemptionDto>>> {
        if (requestParameters["offerId"] == null) {
            throw new runtime.RequiredError(
                "offerId",
                'Required parameter "offerId" was null or undefined when calling offerRedemptions().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/offers/{offerId}/redemptions`.replace(
                    `{${"offerId"}}`,
                    encodeURIComponent(String(requestParameters["offerId"])),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(OfferRedemptionDtoFromJSON),
        );
    }

    /**
     * List an Offer\'s redemptions. The redeeming user is included only for JC staff with system_user_account_manage permission
     */
    async offerRedemptions(
        requestParameters: OfferRedemptionsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<OfferRedemptionDto>> {
        const response = await this.offerRedemptionsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Offers OData, scoped to the user\'s organisation (JC admins see all orgs)
     */
    async offersODataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<OfferDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/offers-odata`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(OfferDtoFromJSON),
        );
    }

    /**
     * Offers OData, scoped to the user\'s organisation (JC admins see all orgs)
     */
    async offersOData(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<OfferDto>> {
        const response = await this.offersODataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Revoke a single user\'s redemption of an Offer.
     */
    async revokeOfferRedemptionRaw(
        requestParameters: RevokeOfferRedemptionRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["offerId"] == null) {
            throw new runtime.RequiredError(
                "offerId",
                'Required parameter "offerId" was null or undefined when calling revokeOfferRedemption().',
            );
        }

        if (requestParameters["userAccountId"] == null) {
            throw new runtime.RequiredError(
                "userAccountId",
                'Required parameter "userAccountId" was null or undefined when calling revokeOfferRedemption().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/offers/{offerId}/redemptions/{userAccountId}`
                    .replace(
                        `{${"offerId"}}`,
                        encodeURIComponent(
                            String(requestParameters["offerId"]),
                        ),
                    )
                    .replace(
                        `{${"userAccountId"}}`,
                        encodeURIComponent(
                            String(requestParameters["userAccountId"]),
                        ),
                    ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Revoke a single user\'s redemption of an Offer.
     */
    async revokeOfferRedemption(
        requestParameters: RevokeOfferRedemptionRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.revokeOfferRedemptionRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Revoke ALL redemptions of an Offer, stopping every redeemed user\'s discount. Works regardless of the Offer\'s status, eg to clean up after an offer was archived.
     */
    async revokeOfferRedemptionsRaw(
        requestParameters: RevokeOfferRedemptionsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["offerId"] == null) {
            throw new runtime.RequiredError(
                "offerId",
                'Required parameter "offerId" was null or undefined when calling revokeOfferRedemptions().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/offers/{offerId}/redemptions`.replace(
                    `{${"offerId"}}`,
                    encodeURIComponent(String(requestParameters["offerId"])),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Revoke ALL redemptions of an Offer, stopping every redeemed user\'s discount. Works regardless of the Offer\'s status, eg to clean up after an offer was archived.
     */
    async revokeOfferRedemptions(
        requestParameters: RevokeOfferRedemptionsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.revokeOfferRedemptionsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Set the device groups an Offer applies to (full replace). Any group type in the offer\'s organisation is allowed, eg the Organisation group covers every device in the org. The user must have view access to every group. Omit deviceGroupTags to unlink all groups.
     */
    async setOfferDeviceGroupsRaw(
        requestParameters: SetOfferDeviceGroupsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["offerId"] == null) {
            throw new runtime.RequiredError(
                "offerId",
                'Required parameter "offerId" was null or undefined when calling setOfferDeviceGroups().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["deviceGroupTags"] != null) {
            queryParameters["deviceGroupTags"] = requestParameters[
                "deviceGroupTags"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/offers/{offerId}/device-groups`.replace(
                    `{${"offerId"}}`,
                    encodeURIComponent(String(requestParameters["offerId"])),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set the device groups an Offer applies to (full replace). Any group type in the offer\'s organisation is allowed, eg the Organisation group covers every device in the org. The user must have view access to every group. Omit deviceGroupTags to unlink all groups.
     */
    async setOfferDeviceGroups(
        requestParameters: SetOfferDeviceGroupsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.setOfferDeviceGroupsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Update an Offer\'s details, status and/or validity window. Status may only be switched between Active and Disabled; archiving is done by DeleteOffer, and Archived offers cannot be modified. Device group links are managed via SetOfferDeviceGroups. Note changing discountPercent changes future charges for users who have already redeemed.
     */
    async updateOfferRaw(
        requestParameters: UpdateOfferRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["offerId"] == null) {
            throw new runtime.RequiredError(
                "offerId",
                'Required parameter "offerId" was null or undefined when calling updateOffer().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/offers/{offerId}`.replace(
                    `{${"offerId"}}`,
                    encodeURIComponent(String(requestParameters["offerId"])),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: OfferRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Update an Offer\'s details, status and/or validity window. Status may only be switched between Active and Disabled; archiving is done by DeleteOffer, and Archived offers cannot be modified. Device group links are managed via SetOfferDeviceGroups. Note changing discountPercent changes future charges for users who have already redeemed.
     */
    async updateOffer(
        requestParameters: UpdateOfferRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.updateOfferRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
